import React, { useCallback, useMemo } from 'react'
import { hooks } from '@front/volcanion'

import Callbacks from './callbacks'

const withContainer = Component => props => {
  const [isManagingRecord] = hooks.useFormState('isManagingRecord')
  const [user_auth_id] = hooks.useFormState('user_auth_id')
  const [supported_languages] = hooks.useSetting('supported_languages')
  const [status] = hooks.useFieldValues(['status'])
  const [first_name, last_name, designation] = hooks.useFieldValues(['info.first_name', 'info.last_name', 'customerinfo.name'])

  const [, { openDialog }] = hooks.useDialogs()
  const [, setSuspendedState] = hooks.useFormState('suspended')

  const statusChange = useCallback(Callbacks.statusChangeHandler(openDialog, setSuspendedState), [openDialog, setSuspendedState])
  const handleClientNumberChange = useCallback(hooks.useRecordExist('user', 'customerinfo.client_number'), [])

  const color = useMemo(() => {
    if (!!_.includes(['inactive', 'archived', 'suspended'], status)) return 'orange'
    else if (status === 'active') return 'green'
    else return 'red'
  }, [status])

  const mergedProps = {
    user_auth_id,
    namesRequired: !designation,
    designationRequired: !first_name && !last_name,
    supported_languages,
    isManagingRecord,
    color,
    statusChange,
    handleClientNumberChange,
  }

  return (
    <Component {...mergedProps} />
  )
}
export default withContainer
